import React, { Fragment } from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";
import NoData from "./NoData";

const OtherTableData = ({ data }) => {
  const styles = StyleSheet.create({
    othercontainer: {
      flexDirection: "row",
      alignItems: "center",
      fontStyle: "bold",
      paddingBottom: "5px",
      paddingTop: "10px",
      paddingLeft: "15px",
      border: "1px solid #E4E4E4",
      borderRadius: "5px",
      width: "100%",
      marginTop: "5px",
    },
    departure: {
      width: "20%",
      fontSize: "11px",
      color: "#333333",
    },
    arrival: {
      width: "20%",
      fontSize: "11px",
      color: "#333333",
    },
    form: {
      width: "15%",
      fontSize: "11px",
      color: "#333333",
    },
    to: {
      width: "15%",
      fontSize: "11px",
      color: "#333333",
    },
    description: {
      width: "20%",
      fontSize: "11px",
      color: "#333333",
    },
  });
  return (
    <Fragment>
      {data && data?.other_bookings?.length > 0 ? (
        data?.other_bookings?.map((items) => (
          <View style={styles.othercontainer}>
            <Text style={styles.departure}>
              {items?.departure_date ? items?.departure_date : "-"}
            </Text>
            <Text style={styles.arrival}>
              {items?.arrival_data ? items?.arrival_data : "-"}
            </Text>
            <Text style={styles.form}>
              {items?.from_city ? items?.from_city : "-"}
            </Text>
            <Text style={styles.to}>
              {items?.to_city ? items?.to_city : "-"}
            </Text>
            <Text style={styles.description}>
              {items?.description ? items?.description : "-"}
            </Text>
          </View>
        ))
      ) : (
        <NoData title="Other Data" />
      )}
    </Fragment>
  );
};

export default OtherTableData;
